/*
Markup : 

<div class="js-comments">
	<form action="" method="post" data-comment-post="comment.php">
		<div class="js-form-error"></div>
		<input type="hidden" name="foo" value="bar" />
	</form>
	<div class="js-form-confirm"></div>

	<ul>
		<li data-comment-id="123456">
			<a href="#" data-comment-like="like.php">like</a>
			<a href="#" data-comment-dislike="like.php">dislike</a>
			<a href="#" data-comment-alert="alert.php">alert</a>
		</li>
	</ul>
</div>


Setup : 

$(function() {
	$(".js-comments").commenting();
});
*/
;(function ( $, window, document, undefined ) {
    var pluginName = "commenting",
        defaults = {
			charsMax: 500        	
        };

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

		init: function() {
			this.setElements();
			this.setVars();
			this.setEvents();

			this.$bydate.hide();
			if (this.commentsCount) {
				var text = (this.commentsCount == 1) ? "commentaire" : "commentaires";
				this.$title.html('<span class="strong">'+ this.commentsCount +'</span> '+ text);
			}
		},

		setElements: function() {
			this.$element = $(this.element);
			this.$title = this.$element.find(".js-comments-title");
			this.$form = this.$element.find(".js-comments-form");
			this.$textarea = this.$form.find(".js-comments-entry");
			this.$queryInput = this.$form.find("[name='query']");
			this.$replyInput = this.$form.find("[name='idParent']");
			this.$replyInfos = this.$element.find('.js-comments-replyinfos')
			this.$all = this.$element.find(".js-comments-all");
			this.$bydate = this.$element.find(".js-comments-bydate");
			this.$byvote = this.$element.find(".js-comments-byvote");
		},

		setVars: function() {
			this.urlPost = this.$element.data("comments-post");
			this.urlLike = this.$element.data("comments-like");
			this.urlAlert = this.$element.data("comments-alert");
			this.commentsCount = (this.$element.find("[data-comments-count]").length) ? this.$element.find("[data-comments-count]").data("comments-count") : 0;
		},

		setEvents: function() {
			this.$form.on("submit", $.proxy(this.postComment, this));
			this.$textarea.on("keypress keyup change", $.proxy(this.setNbChars, this));
			$(document).on("click", ".js-comments-reply", $.proxy(this.setReply, this));
			$(document).on("click", ".js-comments-cancelreply", $.proxy(this.unsetReply, this));
			$(document).on("click", ".js-comments-alert", $.proxy(this.setAlert, this));
			$(document).on("click", ".js-comments-like, .js-comments-dislike", $.proxy(this.setLike, this));
            $(document).on("tabing-ready", ".js-tabs", $.proxy(function() {
                this.$bydate.removeAttr("style");        
            }, this));
			this.$all.on("click", $.proxy(function(e) {
				$('.js-comments-bydate').trigger('click');
				e.preventDefault();
			}, this));
		},

		setNbChars: function (e) {
			var nb = this.settings.charsMax - this.$textarea.val().length;
			if (nb >= 0) {
				var msg = nb +' caractère'+ (nb>1?'s':'') +' restant'+ (nb>1?'s':'');
			} else {
				nb = -1 * nb;
				var msg = '<span class="comments__nbcharsAlert">'+ nb +' caractères en trop</span>';
			}
			$('.js-comments-nbchars').html(msg);
		},

		postComment: function(e) {
			if (this.$xhr)
				return false;

			connection.login($.proxy(function() {
				var data = {};
				data["query"] = (this.$queryInput.length) ? this.$queryInput.val() : "comment";
				data["text"] = this.$textarea.val();
				if (this.$replyInput.length)
					data["idParent"] = this.$replyInput.val();
				
				this.$xhr = $.ajax(this.urlPost, {
					type: "POST",
					data: data
				}).always($.proxy(function(json) {
					if (json.code && json.code == 200) {
						this.$textarea.val('').trigger("change");
						this.$replyInfos.empty();
						setTimeout($.proxy(function() {
							this.setConfirm(json.message);
						}, this), 500);
					} else if (json.message) {
						this.setError(json.message);
					} else {
						this.setError("Une erreur est survenue");
					}
					this.$xhr = null;
				}, this));
			}, this));

			e.preventDefault();
		},

		setReply: function (e) {
			if (!this.inappCheckLoggin())
				return false;
			
			var $reply = $(e.currentTarget);
			var $comment = $reply.parents("[data-comment-id]");
			this.$textarea.val('').trigger("change");
			this.$replyInput.val($comment.data("comment-id"));
			this.$replyInfos.html('En réponse à ' + $comment.find(".js-comments-author").text() +' <a href="#" class="js-comments-cancelreply">X</a>');
			$('html, body').scrollTop(this.$element.offset().top - 84);
			e.preventDefault();
		},

		unsetReply: function (e) {
			this.$replyInfos.empty();
			this.$replyInput.val('');
			this.$textarea.val('').trigger("change");
			e.preventDefault();
		},

		setLike: function(e) {
			if (!this.inappCheckLoggin())
				return false;

			var $like = $(e.currentTarget);
			var $comment = $like.parents("[data-comment-id]");
			var likeType = $like.hasClass("js-comments-dislike") ? "dislike": "like";

			if (this.$xhr || $comment.find(".js-comments-like.is-active, .js-comments-dislike.is-active").length)
				return false;

			connection.login($.proxy(function() {
				this.$xhr = $.ajax(this.urlLike, {
					type: "POST",
					data: {
						query: likeType,
						typedoc: "commentaire",
						iddoc: $comment.data("comment-id")
					}
				}).always($.proxy(function(json) {
					if (json.code && json.code == 200) {
						var count = (json.datas && json.datas.count) ? json.datas.count : parseInt($like.find(".js-comments-like-count").text()) + 1;
						$like.find(".js-comments-like-count").text(count);
						$like.addClass("is-active");
					} else if (json.message) {
						this.setError(json.message);
					} else {
						this.setError("Une erreur est survenue");
					}
					this.$xhr = null;
				}, this));
			}, this));

			e.preventDefault();
		},

		setAlert: function(e) {
			if (!this.inappCheckLoggin())
				return false;

			var $alert = $(e.currentTarget);
			var $comment = $alert.parents("[data-comment-id]");

			if (this.$xhr || $comment.find(".js-comments-alert.is-active").length)
				return false;

			this.$xhr = $.ajax(this.urlAlert, {
				type: "POST",
				data: {
					query: 'signal',
					idcomment: $comment.data("comment-id")
				}
			}).always($.proxy(function(json) {
				if (json.code && json.code == 200) {
					$alert.addClass("is-active");
					this.setConfirm(json.message);
				} else if (json.message) {
					this.setError(json.message);
				} else {
					this.setError("Une erreur est survenue");
				}
				this.$xhr = null;
			}, this));

			e.preventDefault(); 
		},

		inappCheckLoggin: function() {
			if ($("html").hasClass("in-app")) {
				connection.getCookie();
				if (!connection.isLoggedIn()) {
					$(".js-comments-inapp")[0].click();
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		},

		setError: function(message) {
			var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
			html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
			html += '</div>';
            popin.setPopin({
                html: html,
                classname: "popin popin--xs popin--auto"
            });
		},

		setConfirm: function(message) {
			var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
			html += '<p class="paragraph"><span class="message message--success">' + message +'</span></p>';
			html += '</div>';
            popin.setPopin({
                html: html,
                classname: "popin popin--toaster",
                globalClassname: "is-toasting"
            });
		}

	});

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );